// 这是导流产品要做的人脸流程

import { getKey } from '@/assets/utils'
import store from '@/store' // 导入 store

/**
 * 导流产品人脸流程
 * @param {Object} context - Vue 组件实例上下文，用于访问 $sensors 等
 * @param {Object} query - 查询参数
 * @returns {Promise} 返回一个 Promise，可以用 await 调用
 */
export default (context, { redirectUrl }) => {
  return new Promise(async (resolve, reject) => {
    if (!['/authentication/api-result', '/river/diversion?tabActive=1'].includes(redirectUrl)) {
      resolve() // 如果 redirectUrl 不合法，直接返回
      return
    }
    try {
      const configIds = getKey('configIds')
      
      // 使用传入的 context 来访问 $sensors
      if (context && context.$sensors) {
        context.$sensors.track('Withdraw_Element_Click', { 
          product_type: 'diversion', 
          product_code: JSON.stringify(configIds) 
        })
      }
      
      // 调用 creditApply action
      const { success, data } = await store.dispatch('apiDiversion/creditApply', { 
        configIds: configIds 
      })
      if (!success) {
        throw new Error('creditApply 调用失败')
      }
      context.$router.replace({ 
        path: redirectUrl,
        query: {
          creditApply: data.applyNo
      } })
      // resolve() // 成功时返回完整响应
    } catch (error) {
      console.error('调用 creditApply 失败:', error)
      reject(error) // 失败时拒绝 promise
    }
  })
}